// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"8b8b9d90","98":"caefec36","204":"6b7bb8fa","233":"7921e0aa","377":"4c31618a","392":"4e1cdccb","453":"e931e070","572":"d6450ea4","756":"9d470028","844":"b19678bb"}[chunkId] + ".chunk.js";
};